import React from "react";
import Aic from "../../../assets/Logo/aic.png";
import DSTNIDHI from "../../../assets/DashboardImages/DST-NIDHI.png";
import MpStartup from "../../../assets/Logo/mp_startup.png";
import SeedFund from "../../../assets/Logo/seedfund.png";
import StartupIndia from "../../../assets/Logo/startup_india.png";

const TrustUs = () => {
  const logos = [
    { src: Aic, alt: "Aic" },
    { src: DSTNIDHI, alt: "DST NIDHI" },
    { src: MpStartup, alt: "MpStartup" },
    { src: SeedFund, alt: "SeedFund" },
    { src: StartupIndia, alt: "StartupIndia" },
  ];

  return (
    <div className="w-full bg-white dark:bg-gray-900 py-10 xs:py-12 sm:py-16 md:py-20 px-4 xs:px-4 sm:px-6 mt-10 xs:mt-12 sm:mt-16 md:mt-20 md:mb-20">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8 xs:mb-10 sm:mb-12">
          <h2 className="text-3xl xs:text-4xl sm:text-4xl md:text-5xl lg:text-6xl font-normal text-gray-900 dark:text-white mb-3 xs:mb-4 sm:mb-6 tracking-wide">
            Recognized by
          </h2>
          <div className="flex justify-center">
            <div className="w-20 xs:w-24 sm:w-28 h-1 bg-gradient-to-r from-amber-400 to-amber-600 rounded-full"></div>
          </div>
        </div>

        {/* Desktop/Tablet Version - Infinite Scroll */}
        <div className="hidden sm:block w-full bg-gray-100 dark:bg-gray-800 py-8 xs:py-10 sm:py-12 overflow-hidden rounded-xl">
          <div className="flex w-max animate-infinite-scroll hover:pause-animation">
            {/* Render logos 3 times for seamless loop */}
            {[...Array(3)].map((_, setIndex) => (
              <div key={setIndex} className="flex items-center">
                {logos.map((logo, index) => (
                  <img
                    key={`${setIndex}-${index}`}
                    src={logo.src}
                    alt={logo.alt}
                    className="h-14 xs:h-16 sm:h-18 md:h-20 w-auto mx-8 xs:mx-10 sm:mx-12 md:mx-16 object-contain"
                  />
                ))}
              </div>
            ))}
          </div>
        </div>

        {/* Mobile Version - Grid Layout */}
        <div className="sm:hidden w-full">
          <div className="grid grid-cols-2 gap-6 xs:gap-8">
            {logos.map((logo, index) => (
              <div 
                key={index} 
                className="flex items-center justify-center bg-gray-50 dark:bg-gray-800 p-4 xs:p-5 rounded-xl shadow-sm hover:shadow-md transition-shadow min-h-[100px]"
              >
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className="h-12 xs:h-14 w-auto object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustUs;
